import type { GfSizeTableData } from '@/types';
import styles from './GfSizeTable.module.scss';

/**
 * サイズ表テーブル（純粋な描画コンポーネント）
 * タイトルやアコーディオンは含まない。呼び出し側で制御する。
 */
function GfSizeTable({ sizeTableData }: { sizeTableData: GfSizeTableData }) {
  return (
    <table className={styles.sizeTable}>
      <thead className={styles.sizeTableHeader}>
        <tr>
          {sizeTableData.headers.map((header) => (
            <th key={header.key} className={styles.sizeTableHeaderCell}>
              {header.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {sizeTableData.rows.map((row) => (
          <tr key={row.id} className={styles.sizeTableRow}>
            {sizeTableData.headers.map((header) => (
              <td key={header.key} className={styles.sizeTableDataCell}>
                {row[header.key] ?? '-'}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default GfSizeTable;
